(function () {
    'use strict';

    angular.module("imApp").factory("stockCountDataService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 983,
                    parameters: parms || {}
                });
            },
            listStockCountDatas: function (parms) {
                return $ihttp.post({
                    method: 984,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
